
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

interface Descarga {
  id: number;
  nombre: string;
  tipo: string;
  formato: string;
  categoria: string;
  descripcion: string;
  url: string;
  imagen: string;
  archivo: string;
}

const catalogosData = [
  {
    name: "Catálogo Acabados Lacados",
    file: "catalogo_acabados_lacados.pdf",
    portada: "/images/catalogos/foto_catalogo_acabados_lacados.png",
    descripcion: "Descubre nuestra gama de acabados lacados, colores y texturas para personalizar tu baño con estilo y calidad."
  },
  {
    name: "Catálogo Acabados Maderas",
    file: "catalogo_acabados_maderas.pdf",
    portada: "/images/catalogos/foto_catalogo_acabados_maderas.png",
    descripcion: "Explora las opciones de madera natural y acabados cálidos para ambientes elegantes y acogedores."
  },
  {
    name: "Catálogo Acabados Porcelánico",
    file: "catalogo_acabados_porcelanico.pdf",
    portada: "/images/catalogos/foto_catalogo_acabados_porcelanico.png",
    descripcion: "Soluciones en porcelánico de alta resistencia y diseño contemporáneo para tu baño."
  },
  {
    name: "Catálogo Maderas Naturales",
    file: "catalogo_maderas_naturales.pdf",
    portada: "/images/catalogos/foto_catalogo_maderas_naturales.png",
    descripcion: "Catálogo dedicado a maderas naturales seleccionadas para muebles y detalles exclusivos."
  },
  {
    name: "Catálogo Navamuel",
    file: "catalogo_navamuel.pdf",
    portada: "/images/catalogos/foto_catalogo_navamuel.png",
    descripcion: "Nuestro catálogo general con todas las colecciones, novedades y soluciones para el baño."
  },
  {
    name: "Catálogo Piedra Natural y Compact",
    file: "catalogo_piedra_natural_y_compact.pdf",
    portada: "/images/catalogos/foto_catalogo_piedra_natural_y_compact.png",
    descripcion: "Inspiración y posibilidades en piedra natural y materiales compactos para superficies y lavabos."
  }
];

const descargas: Descarga[] = catalogosData.map((catalogo, index) => ({
  id: index + 1,
  nombre: catalogo.name,
  tipo: 'Catálogo',
  formato: 'PDF',
  categoria: 'catalogo',
  descripcion: catalogo.descripcion,
  url: '#',
  imagen: catalogo.portada,
  archivo: catalogo.file
}));

const categorias = [
  { id: 'todos', nombre: 'Todos', icono: 'ri-file-list-3-line' },
  { id: 'catalogo', nombre: 'Catálogos', icono: 'ri-book-open-line' }
];

export default function DescargasPage() {
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('todos');
  const [descargaAmpliada, setDescargaAmpliada] = useState<Descarga | null>(null);

  const descargasFiltradas = categoriaSeleccionada === 'todos' 
    ? descargas 
    : descargas.filter(descarga => descarga.categoria === categoriaSeleccionada);

  const abrirDescargaAmpliada = (descarga: Descarga) => {
    setDescargaAmpliada(descarga);
    document.body.style.overflow = 'hidden';
  };

  const cerrarDescargaAmpliada = () => {
    setDescargaAmpliada(null);
    document.body.style.overflow = 'unset';
  };

  const descargarArchivo = (descarga: Descarga) => {
    // Crear un enlace temporal para la descarga
    const link = document.createElement('a');
    link.href = `/downloads/catalogos/${descarga.archivo}`;
    link.download = descarga.archivo;
    link.target = '_blank';
    
    // Agregar al DOM, hacer clic y remover
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Mostrar mensaje de confirmación
    console.log(`Descargando: ${descarga.nombre}`);
    
    // Cerrar el modal después de iniciar la descarga
    setTimeout(() => {
      cerrarDescargaAmpliada();
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <div className="bg-white min-h-screen flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center w-full">
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-light text-gray-900 mb-6 sm:mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>DESCARGAS</h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed px-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
            Accede a toda nuestra documentación técnica, catálogos, manuales y herramientas profesionales.
            <br className="hidden sm:block" /><br className="hidden sm:block" />
            Recursos completos para profesionales y clientes
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Descargas Section */}
        <div className="bg-white rounded-lg overflow-hidden">

          {/* Filtros de Categoría */}
          <div className="p-4 sm:p-6 border-b border-gray-200">
            <div className="flex flex-wrap gap-2 sm:gap-3">
              {categorias.map((categoria) => (
                <button
                  key={categoria.id}
                  onClick={() => setCategoriaSeleccionada(categoria.id)}
                  className={`flex items-center space-x-2 px-3 sm:px-4 py-2 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer text-sm sm:text-base ${
                    categoriaSeleccionada === categoria.id
                      ? 'bg-[#191a19] text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <i className={`${categoria.icono} text-sm`}></i>
                  <span className="font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>{categoria.nombre}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Downloads Grid */}
          <div className="p-4 sm:p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {descargasFiltradas.map((descarga) => (
                <div 
                  key={descarga.id} 
                  className="group cursor-pointer bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300"
                  onClick={() => abrirDescargaAmpliada(descarga)}
                >
                  <div className="aspect-[4/3] bg-gray-100 overflow-hidden">
                    <img
                      src={descarga.imagen}
                      alt={descarga.nombre}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-3 sm:p-4">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-1 rounded" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                        {descarga.tipo}
                      </span>
                      <span className="text-xs text-gray-400" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                        {descarga.formato}
                      </span>
                    </div>
                    <h3 className="text-sm font-medium text-gray-900 mb-2 line-clamp-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {descarga.nombre}
                    </h3>
                    <p className="text-xs text-gray-600 mb-3 line-clamp-2" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {descarga.descripcion}
                    </p>
                    <div className="flex items-center justify-end">
                      <div className="flex items-center space-x-1 text-gray-400 group-hover:text-black transition-colors">
                        <i className="ri-download-line text-sm"></i>
                        <span className="text-xs" style={{ fontFamily: 'Cormorant Garamond, serif' }}>Descargar</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Descarga Ampliada */}
      {descargaAmpliada && (
        <div className="fixed inset-0 bg-[#191a19]/80 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl w-full max-h-[95vh] bg-white rounded-lg overflow-hidden">
            <button
              onClick={cerrarDescargaAmpliada}
              className="absolute top-3 right-3 sm:top-4 sm:right-4 z-10 w-8 h-8 sm:w-10 sm:h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center cursor-pointer transition-colors"
            >
              <i className="ri-close-line text-lg sm:text-xl text-gray-800"></i>
            </button>
            
            <div className="p-4 sm:p-6 max-h-[95vh] overflow-y-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
                <div className="aspect-[4/3] overflow-hidden rounded-lg">
                  <img
                    src={descargaAmpliada.imagen}
                    alt={descargaAmpliada.nombre}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                <div className="flex flex-col justify-center space-y-4 sm:space-y-6">
                  <div>
                    <div className="flex flex-wrap items-center gap-2 sm:gap-3 mb-3">
                      <span className="text-xs sm:text-sm font-medium text-gray-500 bg-gray-100 px-2 sm:px-3 py-1 rounded-full" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                        {descargaAmpliada.tipo}
                      </span>
                      <span className="text-xs sm:text-sm text-gray-400" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                        {descargaAmpliada.formato}
                      </span>
                    </div>
                    <h2 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-3 sm:mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
                      {descargaAmpliada.nombre}
                    </h2>
                    <p className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      {descargaAmpliada.descripcion}
                    </p>
                  </div>
                  
                  <div className="space-y-3 sm:space-y-4">
                    <h3 className="text-lg sm:text-xl font-medium text-gray-800" style={{ fontFamily: 'Playfair Display, serif' }}>Información del archivo</h3>
                    <ul className="space-y-2 text-sm sm:text-base text-gray-600" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
                      <li className="flex items-center justify-between">
                        <span>Formato:</span>
                        <span className="font-medium">{descargaAmpliada.formato}</span>
                      </li>
                      <li className="flex items-center justify-between">
                        <span>Tipo:</span>
                        <span className="font-medium">{descargaAmpliada.tipo}</span>
                      </li>
                      <li className="flex items-center justify-between">
                        <span>Archivo:</span>
                        <span className="font-medium text-xs sm:text-sm break-all">{descargaAmpliada.archivo}</span>
                      </li>
                    </ul>
                  </div>
                  
                  <div className="pt-4">
                    <button
                      onClick={() => descargarArchivo(descargaAmpliada)}
                      className="w-full bg-[#191a19] text-white py-3 px-4 sm:px-6 rounded-lg hover:bg-gray-800 transition-colors flex items-center justify-center space-x-2 cursor-pointer whitespace-nowrap text-sm sm:text-base"
                    >
                      <i className="ri-download-line text-base sm:text-lg"></i>
                      <span className="font-medium" style={{ fontFamily: 'Playfair Display, serif' }}>Descargar catálogo</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
